module.exports = __webpack_public_path__ + "static/media/DevDay_Hackerearth[1].1d8354c1.jpg";